exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".carouselIcon:hover .customize[data-v-468cabc8]{display:block}.carouselIcon .customize[data-v-468cabc8]{display:none}.carouselIcon[data-v-468cabc8]  .el-carousel__container{height:100%!important}.carouselIcon[data-v-468cabc8]  .el-carousel__button{height:3px;width:3px;border-radius:100%}.carouselIcon[data-v-468cabc8]  .is-active .el-carousel__button{height:3px;width:9px;border-radius:3px;background:var(--portalPrimaryColor)}", ""]);

// exports
